import { NgModule } from '@angular/core';

import { SelectSearchComponent } from './select-search.component';
import { MatChipsModule } from '@angular/material/chips';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';
import { MatInputModule } from '@angular/material/input';
import { ReactiveFormsModule } from '@angular/forms';


@NgModule({
    declarations: [
        SelectSearchComponent
    ],
    imports: [
        CommonModule,
        MatChipsModule,
        MatAutocompleteModule,
        MatIconModule,
        MatInputModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatButtonModule,
    ],
    exports: [ SelectSearchComponent ]
})
export class SelectSearchModule {
}